import { LOCALE_COOKIE, normaliseLocale, SupportedLocale } from './config';

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export const readLocaleFromCookieHeader = (cookieHeader?: string): SupportedLocale | null => {
  if (!cookieHeader) {
    return null;
  }
  const parts = cookieHeader.split(';').map((part) => part.trim());
  const match = parts.find((part) => part.startsWith(`${LOCALE_COOKIE}=`));
  if (!match) {
    return null;
  }

  let value: string;

  try {
    value = decodeURIComponent(match.split('=')[1] ?? '');
  } catch {
    return null;
  }

  return value ? normaliseLocale(value) : null;
};

/**
 * Read the TT_LOCALE cookie from document.cookie. Browser-only.
 */
export const readLocaleCookie = (): SupportedLocale | null => {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie.split('; ').find((part) => part.startsWith(`${LOCALE_COOKIE}=`));
  if (!match) {
    return null;
  }

  let value: string;

  try {
    value = decodeURIComponent(match.split('=')[1] ?? '');
  } catch {
    return null;
  }
  return value ? normaliseLocale(value) : null;
};

/**
 * Persist the TT_LOCALE cookie. Browser-only. Cookie is sent to the
 * API on subsequent requests so the API can resolve locale.
 */
export const writeLocaleCookie = (locale: SupportedLocale): void => {
  if (typeof document === 'undefined') {
    return;
  }
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${LOCALE_COOKIE}=${encodeURIComponent(
    locale,
  )}; Path=/; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax${secure}`;
};
